import React from 'react'

const StatusIcon = ({ component: Component, ...props }) => (
  <Component {...props} />
)

export default StatusIcon
